import React from 'react';
import Title from '../../../components/Title/Title';
import './AboutCompany.css';

const AboutCompany = () => {
    return (
        <div className='aboutCompanyContainer container'>

            <Title title="STUDIO SPACEJAM" /> <br />
            <p className='aboutCompanyDesc'>
                Studio Space Jam, the consultancy unit of Space Jam Design & Constriction, is a full service architectural firm located in Dhaka, Bangladesh since 2013. Our professional Team of architects,interior designers, Structural engineers, Electrical Engineers, Plumbing Engineers, estimators and construction professionals comprises one of the promising architectural, engineering and construction firms in the City. Our diverse project portfolio includes buildings across the country and clients in 17 Districts. As reflected in the satisfaction of our numerous repeat clients, Studio Space Jam’s primary objective is to deliver quality services on-time and on-budget for every assignment, regardless of size, scope or location. </p>
        </div>
    );
};

export default AboutCompany;